
import {
    SURVEYSSCREEN_LOAD,
    SURVEYSSCREEN_UNLOAD,
    SURVEYSSCREEN_SET,
} from '../../../../actionDefinitions';

import {
    fetchSurveyFormsSummary,
    _saveSurvey,
} from '../../../../api/v3/AdminApi';

export function loadSurveysScreen() {
    return dispatch => {
        dispatch(loadSurveyFormsSummary());
    };
}

export function loadSurveyFormsSummary() {
    return dispatch =>
        fetchSurveyFormsSummary()
            .then(payload => dispatch({ type: SURVEYSSCREEN_LOAD, payload: { surveyFormsSummary: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYSSCREEN_LOAD, error: true, payload }))
}

export function saveSurvey(surveyToSave) {
    return dispatch =>
        _saveSurvey(surveyToSave)
            .then(payload => dispatch({ type: SURVEYSSCREEN_LOAD, payload: { surveyFormsSummary: payload.result } }))
            .catch(payload => dispatch({ type: SURVEYSSCREEN_LOAD, error: true, payload }))
}


export function updateProps(updatedProps) {
    return dispatch => {
        return dispatch({ type: SURVEYSSCREEN_SET, updatedProps });
    }
}
